import React from "react";
import TicketStatusChevronCircle12 from "../../../../assets/svg/icons/common/TicketStatusChevronCircle12";
import TicketStatusOpen12 from "../../../../assets/svg/icons/common/TicketStatusOpen12";
import TicketStatusXCircle12 from "../../../../assets/svg/icons/common/TicketStatusXCircle12";

const ICONS = {
  check: TicketStatusOpen12,
  x: TicketStatusXCircle12,
  chevron: TicketStatusChevronCircle12,
};

export default function TicketStatusIcon({ type, className }) {
  const Icon = ICONS[type];
  return Icon ? <Icon className={className} /> : null;
}
